export const booleanOptions = [
    { text: "Yes", value: "true" },
    { text: "No", value: "false" },
];

export const statusBooleanOptions = [
    { text: "All", value: "all" },
    { text: "In Progress", value: "InProgress" },
    { text: "Completed", value: "Completed" },
    { text: "Rejected", value: "Rejected" },
];
